import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { takeUntil, timeout } from 'rxjs/operators';
import { BaseComponent } from '../../core';

const GATEWAY_TIMEOUT = 20000;

@Injectable({ providedIn: 'root' })
export class HttpCallerService extends BaseComponent {
  public static readonly RESPONSE_TYPE = {
    TEXT: 'text',
    JSON: 'json',
    BLOB: 'blob',
  };

  constructor(private http: HttpClient) {
    super();
  }

  public get(
    url: string,
    headers: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http
        .get<any>(url, {
          headers,
          observe: 'response',
          responseType: responseType as 'json',
        })
        .pipe(timeout(GATEWAY_TIMEOUT))
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public post(
    url: string,
    data: any,
    headers: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post<any>(url, data, {
          headers,
          observe: 'response',
          responseType: responseType as 'json',
        })
        .pipe(timeout(GATEWAY_TIMEOUT))
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public put(
    url: string,
    data: any,
    headers: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http
        .put<any>(url, data, {
          headers,
          observe: 'response',
          responseType: responseType as 'json',
        })
        .pipe(timeout(GATEWAY_TIMEOUT))
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public patch(
    url: string,
    data: any,
    headers: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http
        .patch<any>(url, data, {
          headers,
          observe: 'response',
          responseType: responseType as 'json',
        })
        .pipe(timeout(GATEWAY_TIMEOUT))
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public delete(
    url: string,
    data: any,
    headers: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http
        .delete<any>(url, {
          headers,
          observe: 'response',
          responseType: responseType as 'json',
          body: data,
        })
        .pipe(timeout(GATEWAY_TIMEOUT))
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
}
